var render = function render(){var _vm=this,_c=_vm._self._c;return _c('horse-table',{attrs:{"headers":_vm.headers,"filters":_vm.filters}})
}
var staticRenderFns = []

export { render, staticRenderFns }